<template>
  <div class="product-card">
    <div class="product-img">
      <div class="placeholder-img">
        <div class="category-badge">{{ product.category }}</div>
        <router-link :to="'/products/' + product.id">
          <img :src="product.images" :title="product.name" :alt="product.name">
        </router-link>
      </div>
    </div>
    <div class="product-info">
      <router-link :to="'/products/' + product.id">
        <h3 class="product-name">{{ product.name }}</h3>
      </router-link>
      <p class="product-price">Rs. {{ (product.price).toLocaleString('en-IN') }}</p>
      <div class="wishlist-action">
        <button @click="toggleWishlist" class="wishlist-btn" :class="{ 'in-wishlist': isInWishlist }">
          <i v-if="isInWishlist" class="fas fa-heart"></i>
          <i v-else class="far fa-heart"></i>
          {{ isInWishlist ? 'In Wishlist' : 'Add to Wishlist' }}
        </button>
      </div>
      <div class="product-actions">
        <router-link :to="'/products/' + product.id" class="btn btn-secondary btn-sm">View Details</router-link>
        <button @click="addToCart" class="btn btn-primary btn-sm">
          <i class="fas fa-shopping-cart"></i> Add to Cart
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ProductCard',
  props: {
    product: {
      type: Object,
      required: true
    }
  },
  computed: {
    isInWishlist() {
      return this.$store.getters.isInWishlist(this.product.id);
    }
  },
  methods: {
    addToCart() {
      this.$store.dispatch('addToCart', {
        product: this.product,
        quantity: 1
      });

      this.$toast.success(`${this.product.name} added to cart!`, {
        timeout: 2000
      });
    },
    toggleWishlist() {
      if (this.isInWishlist) {
        this.$store.dispatch('removeFromWishlist', this.product.id);
        this.$toast.info(`${this.product.name} removed from wishlist`, {
          timeout: 2000
        });
      } else {
        this.$store.dispatch('addToWishlist', this.product);
        this.$toast.success(`${this.product.name} added to wishlist!`, {
          timeout: 2000
        });
      }
    }
  }
}
</script>

<style scoped>
.product-card {
  background-color: white;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease;
}

.product-card:hover {
  transform: translateY(-5px);
}

.product-img {
  position: relative;
  height: 220px;
  overflow: hidden;
}

.placeholder-img {
  width: 100%;
  height: 100%;
  background-color: #f8f9fa;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}

.placeholder-img img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.5s ease;
}

.product-card:hover .placeholder-img img {
  transform: scale(1.1);
}

.category-badge {
  position: absolute;
  top: 10px;
  right: 10px;
  background-color: #4CAF50;
  color: white;
  padding: 5px 10px;
  border-radius: 3px;
  font-size: 12px;
  text-transform: uppercase;
  font-weight: bold;
  z-index: 1;
}

.product-info {
  padding: 20px;
}

.product-name {
  font-size: 16px;
  margin-bottom: 10px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: #333;
}

.product-price {
  font-weight: bold;
  color: #4CAF50;
  margin-bottom: 15px;
}

.wishlist-action {
  margin-bottom: 15px;
}

.wishlist-btn {
  background: none;
  border: none;
  color: #777;
  padding: 0;
  font-size: 14px;
  cursor: pointer;
  display: flex;
  align-items: center;
  transition: color 0.3s;
}

.wishlist-btn:hover {
  color: #e91e63;
}

.wishlist-btn i {
  margin-right: 5px;
}

.wishlist-btn.in-wishlist {
  color: #e91e63;
}

.product-actions {
  display: flex;
  justify-content: space-between;
}

.btn-sm {
  padding: 8px 15px;
  font-size: 13px;
}
</style>
